// extracted by mini-css-extract-plugin
export default {"innerDatatable":"app-core-components-datatables-components-InnerDatatable-module__inner-datatable"};